"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function dcn(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.82702 23.2545C6.25561 22.6707 4.82389 21.7642 3.62402 20.5935L3.73427 20.4007C5.52527 17.571 7.13402 14.6423 8.34527 11.5133C9.63002 8.1945 10.6583 4.788 11.6378 1.368C11.7255 1.06275 11.8298 0.76275 11.9258 0.4605C12.0293 0.579 12.0668 0.68925 12.0983 0.801C12.7133 2.9955 13.308 5.196 13.9463 7.383C15.1088 11.3678 16.7438 15.1477 18.909 18.6908C19.1618 19.1033 19.5915 19.7948 20.199 20.7623C18.9058 21.9744 17.36 22.8847 15.6728 23.4277C14.4293 19.6329 13.1788 15.8404 11.9213 12.0502L11.8058 12.0487C10.9313 14.5065 9.60527 18.2415 7.82702 23.2545ZM12.0563 0.03675H11.9633L12 0L12.0563 0.03675Z", fill: color }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.82702 23.2545C6.25561 22.6707 4.82389 21.7642 3.62402 20.5935L3.73427 20.4007C5.52527 17.571 7.13402 14.6423 8.34527 11.5133C9.63002 8.1945 10.6583 4.788 11.6378 1.368C11.7255 1.06275 11.8298 0.76275 11.9258 0.4605C12.0293 0.579 12.0668 0.68925 12.0983 0.801C12.7133 2.9955 13.308 5.196 13.9463 7.383C15.1088 11.3678 16.7438 15.1477 18.909 18.6908C19.1618 19.1033 19.5915 19.7948 20.199 20.7623C18.9058 21.9744 17.36 22.8847 15.6728 23.4277C14.4293 19.6329 13.1788 15.8404 11.9213 12.0502L11.8058 12.0487C10.9313 14.5065 9.60527 18.2415 7.82702 23.2545ZM12.0563 0.03675H11.9633L12 0L12.0563 0.03675Z", fill: color }));
}
exports["default"] = dcn;
//# sourceMappingURL=dcn.js.map